import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData from '../../Driveanalysis/NoData';
import ChartLoader from '../../Driveanalysis/ChartLoader';
import BucketsTableDuration from './BucketsTableDuration';
import Bucketfast from "./Bucketfast";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../DashboardMain/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales,
  Ticks
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result = []

function FastChargeDuration({ apiend, gloablfilter, type, checkFCD, chartnameFCD }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [check, SetCheck] = useState(checkFCD);
  const [chartname, SetChartName] = useState(chartnameFCD);
  const [toggleFleetBar, setToggleFleetBar] = useState(false);
  let barcolor = "#348393"

  let modal_title = "Slow Charge Duration 20% - 100%";

  const appyData = (data) => {
    res_result = []
    res_result = data;
    let responce = {
      "<250": 0,
      "275": 0,
      "300": 0,
      "325": 0,
      "350": 0,
      "375": 0,
      "400": 0,
      "425": 0,
      "450": 0,
      "475": 0,
      "500": 0,
      "525": 0,
      "550": 0,
      ">=575": 0,
    };
    if (res_result.length !== 0) {
      let temp_result = res_result;
      let id = 0
      let newapiarray = []
      SetApiResponce(res_result)
      temp_result.map(d => {
        let value = d.SC20_100TimeInMin.values["50.0"];
        if (value != null) {
          if (value > 0 && value < 250) {
            responce["<250"] = responce["<250"] + 1;
          } else if (value >= 250 && value < 275) {
            responce["275"] = responce["275"] + 1;
          } else if (value >= 275 && value < 300) {
            responce["300"] = responce["300"] + 1;
          } else if (value >= 300 && value < 325) {
            responce["325"] = responce["325"] + 1;
          } else if (value >= 325 && value < 350) {
            responce["350"] = responce["350"] + 1;
          } else if (value >= 350 && value < 375) {
            responce["375"] = responce["375"] + 1;
          } else if (value >= 375 && value < 400) {
            responce["400"] = responce["400"] + 1;
          } else if (value >= 400 && value < 425) {
            responce["425"] = responce["425"] + 1;
          } else if (value >= 425 && value < 450) {
            responce["450"] = responce["450"] + 1;
          } else if (value >= 450 && value < 475) {
            responce["475"] = responce["475"] + 1;
          } else if (value >= 475 && value < 500) {
            responce["500"] = responce["500"] + 1;
          } else if (value >= 500 && value < 525) {
            responce["525"] = responce["525"] + 1;
          } else if (value >= 525 && value < 550) {
            responce["550"] = responce["550"] + 1;
          } else if (value >= 550 && value < 575) {
            responce["575"] = responce["575"] + 1;
          } else if (value >= 575) {
            responce[">=575"] = responce[">=575"] + 1;
          }
        }
      })

      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);

      loop_keys = ["<250", "275", "300", "325", "350", "375", "400", "425", "450", "475", "500", "525", "550", ">=575"]
      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }

      loop_keys.map(x => {
        if (countcheck)
          res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;color:#348393"]);
      })

      Maxchartdata = {
        datasets: [
          {
            label: "Duration (Min)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  const appyDataFast = (data) => {
    res_result = []
    res_result = data;

    let responce = {
      "<70": 0,
      "80": 0,
      "90": 0,
      "100": 0,
      "110": 0,
      "120": 0,
      "130": 0,
      "140": 0,
      "150": 0,
      "160": 0,
      "170": 0,
      "180": 0,
      ">=180": 0,
    };
    
    if (res_result.length === 0) {
      setChartData((prestate) => []);
    }
    if (res_result.length !== 0) {
      let temp_result = res_result;
      let id = 0

      SetApiResponce(res_result)

      temp_result.map(d => {
        let value = d.FC10_80TimeInMin.values["50.0"];
        if (value != null) {
          if (value > 0 && value < 70) {
            responce["<70"] = responce["<70"] + 1;
          } else if (value >= 70 && value < 80) {
            responce["80"] = responce["80"] + 1;
          } else if (value >= 80 && value < 90) {
            responce["90"] = responce["90"] + 1;
          } else if (value >= 90 && value < 100) {
            responce["100"] = responce["100"] + 1;
          } else if (value >= 100 && value < 110) {
            responce["110"] = responce["110"] + 1;
          } else if (value >= 110 && value < 120) {
            responce["120"] = responce["120"] + 1;
          } else if (value >= 120 && value < 130) {
            responce["130"] = responce["130"] + 1;
          } else if (value >= 130 && value < 140) {
            responce["140"] = responce["140"] + 1;
          } else if (value >= 140 && value < 150) {
            responce["150"] = responce["150"] + 1;
          } else if (value >= 150 && value < 160) {
            responce["160"] = responce["160"] + 1;
          } else if (value >= 160 && value < 170) {
            responce["170"] = responce["170"] + 1;
          } else if (value >= 170 && value < 180) {
            responce["180"] = responce["180"] + 1;
          } else if (value >= 180) {
            responce[">=180"] = responce[">=180"] + 1;
          }
        }
      })
      let res_result_final = [["Element", "Count", { role: "style" }]]

      let loop_keys = Object.keys(responce);

      loop_keys = ["<70", "80", "90", "100", "110", "120", "130", "140", "150", "160", "170", "180", ">=180"]

      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }
      loop_keys.map(x => {
        if (countcheck)
          res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;color:#FFA650"]);
      })
      const labels = ["<70", "80", "90", "100", "110", "120", "130", "140", "150", "160", "170", "180", ">=180"]

      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Duration (Min)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },

        ]
      };
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  let hAxis = {};

  if (apiend == "rangebarchart") {
    modal_title = "OBC max temperature"
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Range (Km)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
    };
  }

  if (apiend == "energybarchart") {
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Wh / Km',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Duration (Min)'
        },
        suggestedMin: 0,
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        }
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Vehicle Count'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {

    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Duration (Min)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" }
    , legend: "none",
    series: {
      0: { color: barcolor },
    },
  };

  useEffect(() => {
    if (type === "Slow") {
      barcolor = "#348393"
      SetCheck("SC20_100TimeInMin")
      SetChartName("Slow charge duration 20% - 100%");
      fetchData({ url: API_URL_MAIN + "chargingpage/" + apiend, body: { filterdata: gloablfilter } }, appyData)
    } else {
      SetCheck("FC10_80TimeInMin")
      barcolor = "#FFA650"
      SetChartName("Fast charge duration 10% - 80%")
      fetchData({ url: API_URL_MAIN + "chargingpage/chargeduration_fast", body: { filterdata: gloablfilter } }, appyDataFast)
    }
  }, [gloablfilter, type])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
      <WaterMark />
      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
        {
          eventName: 'select',
          callback: ({ chartWrapper }) => {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            if (selection.length === 1) {
              const [selectedItem] = selection;
              const { row } = selectedItem;

              const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
              const count = chartWrapper.getDataTable().Wf[row].c[1].v;

              let filtered_temp = [];
              if (count !== 0) {
                if (check === "SC20_100TimeInMin") {
                  filtered_temp = apiresponce.filter(x => {
                    if (x.SC20_100TimeInMin.values["50.0"] < barvalue && x.SC20_100TimeInMin.values["50.0"] >= barvalue - 25) {
                      return x;
                    }
                    else if (x.SC20_100TimeInMin.values["50.0"] >= 575 && barvalue === ">=575") {
                      return x
                    }
                    else if (x.SC20_100TimeInMin.values["50.0"] < 250 && barvalue === "<250") {
                      return x
                    }
                  })
                }
                else {
                  filtered_temp = apiresponce.filter(x => {
                    if (x.FC10_80TimeInMin.values["50.0"] < barvalue && x.FC10_80TimeInMin.values["50.0"] >= barvalue - 10) {
                      return x;
                    }
                    else if (x.FC10_80TimeInMin.values["50.0"] >= 180 && barvalue === ">=180") {
                      return x
                    }
                    else if (x.FC10_80TimeInMin.values["50.0"] < 70 && barvalue === "<70") {
                      return x
                    }
                  })
                }

                function compareObjects(object1, object2, key) {
                  let obj1 = 0
                  let obj2 = 0
                  if (check === "SC20_100TimeInMin") {
                    obj1 = object1.SC20_100TimeInMin.values["50.0"]
                    obj2 = object2.SC20_100TimeInMin.values["50.0"]
                  } else {
                    obj1 = object1.FC10_80TimeInMin.values["50.0"]
                    obj2 = object2.FC10_80TimeInMin.values["50.0"]
                  }
                  if (obj1 > obj2) {
                    return -1
                  }
                  if (obj1 < obj2) {
                    return 1
                  }
                  return 0
                }

                filtered_temp.sort((value1, value2) => {
                  return compareObjects(value1, value2, 'value')
                })
                SetfilteredData(prestate => filtered_temp);
                window.$('#exampleModal__' + apiend).modal('show');
              }
            }
          }
        }
      ]}
      /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  {(check === "SC20_100TimeInMin") ? <BucketsTableDuration data={filteredData} /> : <Bucketfast data={filteredData} />}
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FastChargeDuration;